/**
 * Search helpers shared by the spreadsheet-style Grid.
 */

/** Normalizes user-entered search text for case- and accent-insensitive matching. */
export function normalizeGridSearchText(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

/**
 * Returns true when every search term occurs in at least one of the supplied cell texts.
 * Terms are independent, so they may occur in different columns or with other text between them.
 */
export function matchesGridSearch(query: string, cellTexts: readonly string[]): boolean {
  const terms = normalizeGridSearchText(query).trim().split(/\s+/).filter(Boolean)
  if (terms.length === 0) return true

  const normalizedCells = cellTexts.map(normalizeGridSearchText)
  return terms.every((term) => normalizedCells.some((cellText) => cellText.includes(term)))
}
